import { FC } from 'react';
import { Column } from 'primereact/column';
import { formatNumber } from '@agro1desenvolvimento/utils-js';
import AutoSortTable from '../../../../../components/AutoSortTable';
import defaultColumnProps from '../../../../../utils/default-column-props';
import { InsumoRow } from '../../../types';

const ResumoInsumosTable: FC<{ insumos: InsumoRow[] }> = ({ insumos }) => (
  <div className="col-6">
    <h2 className="pl-2">Total de Insumos</h2>
    <AutoSortTable
      removableSort
      sortField="descricao"
      dataKey="id"
      value={insumos}
      emptyMessage="Nenhum insumo adicionado."
      stripedRows
    >
      <Column
        {...defaultColumnProps('left')}
        header="Insumo"
        field="descricao"
        body={(insumo) => insumo.descricao ?? 'INSUMO INDISPONÍVEL'}
      />
      <Column
        {...defaultColumnProps()}
        header="Total"
        field="total"
        body={(insumo: InsumoRow) => {
          const formattedQuantidade = formatNumber(insumo.total || 0, {
            maximumFractionDigits: 4,
          });
          const unidade = insumo.unidade?.abreviatura || '';
          return `${formattedQuantidade} ${unidade}`;
        }}
      />
    </AutoSortTable>
  </div>
);

export default ResumoInsumosTable;
